<a (click)="changeView()">
    <img src="assets/images/edit-pencil.png" [ngStyle]="pencilEditStyle" />
</a>
